// Minimal class-based component system.
// Subclass and override `template()` (returns HTML string) and optional `mount()` (post-render DOM hook).
// Reactive: call `setState(patch)` to merge state and re-render in place.

export class Component {
  constructor(props = {}) {
    this.props = props;
    this.state = {};
    this.el = null;
    this._children = [];
    this._mounted = false;
  }

  setState(patch) {
    this.state = { ...this.state, ...patch };
    if (this._mounted) this._rerender();
  }

  template() { return ''; }
  mount() {}
  unmount() {}

  on(selector, event, handler) {
    if (!this.el) return;
    const targets = this.el.querySelectorAll(selector);
    targets.forEach((t) => t.addEventListener(event, handler));
  }

  render(target) {
    const html = this.template();
    const wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    const el = wrapper.firstElementChild || wrapper;
    if (target) {
      target.replaceChildren(el);
    }
    this.el = el;
    this._mounted = true;
    this.mount();
    return el;
  }

  _rerender() {
    if (!this.el || !this.el.parentNode) return;
    const parent = this.el.parentNode;
    const wrapper = document.createElement('div');
    wrapper.innerHTML = this.template();
    const next = wrapper.firstElementChild || wrapper;
    parent.replaceChild(next, this.el);
    this.el = next;
    this.mount();
  }

  destroy() {
    this.unmount();
    if (this.el && this.el.parentNode) this.el.parentNode.removeChild(this.el);
    this.el = null;
    this._mounted = false;
  }
}

// Escape helper for safe interpolation of user data into HTML strings.
export function esc(value) {
  if (value === null || value === undefined) return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
